import { MouseEventHandler } from 'react'
import classNames from 'classnames'
import styles from './Actions.module.css'

interface EditButtonProps {
  onClick: MouseEventHandler<HTMLDivElement>
  isSmallSize?: boolean
}

const EditButton = ({ onClick, isSmallSize = false }: EditButtonProps) => (
  <div
    onClick={onClick}
    className={classNames(
      styles.btn,
      styles.btnSmall,
      styles.btnIcon,
      styles.btnBlueOutline,
      { [styles.isSmallSize]: isSmallSize }
    )}
  >
    <i className={classNames(styles.icon, styles.iconEdit)} />
  </div>
)

export default EditButton
